import { render, staticRenderFns } from "./ResourcePlanningReportMaterialSections.vue?vue&type=template&id=54265bc2&"
import script from "./ResourcePlanningReportMaterialSections.vue?vue&type=script&lang=js&"
export * from "./ResourcePlanningReportMaterialSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports